export enum NumberManagerActionType {
    SET_UPDATE_LIST = 'SET_UPDATE_LIST',
    SET_TELCO_DATA = 'SET_TELCO_DATA',
    SET_TELCO_ID = 'SET_TELCO_ID',
    SET_CLIENT_DATA = 'SET_CLIENT_DATA',
}